import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const styles = {
  primary:
    "bg-kryvo-green text-white hover:bg-kryvo-deep shadow-[0_10px_30px_-10px_rgba(8,122,61,0.45)]",
  lime: "bg-kryvo-lime text-kryvo-deep hover:bg-white",
  outline:
    "border border-kryvo-green/30 bg-white text-kryvo-deep hover:border-kryvo-green hover:bg-kryvo-mist",
  ghostLight:
    "border border-white/25 text-white hover:bg-white/10",
};

const base =
  "group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-colors duration-300 focus-visible:outline-none";

const Inner = ({ children, arrow = true }) => (
  <>
    <span>{children}</span>
    {arrow && (
      <ArrowRight
        className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
        aria-hidden="true"
      />
    )}
  </>
);

export const LinkButton = ({ to, children, variant = "primary", arrow = true, className = "", testId }) => (
  <Link to={to} data-testid={testId} className={`${base} ${styles[variant]} ${className}`}>
    <Inner arrow={arrow}>{children}</Inner>
  </Link>
);

export const ExternalButton = ({ href, children, variant = "primary", arrow = true, className = "", testId }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`${base} ${styles[variant]} ${className}`}
  >
    <Inner arrow={arrow}>{children}</Inner>
  </a>
);

export const ActionButton = ({ type = "button", children, variant = "primary", arrow = true, className = "", testId, disabled, onClick }) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    data-testid={testId}
    className={`${base} ${styles[variant]} ${className} disabled:cursor-not-allowed disabled:opacity-60`}
  >
    <Inner arrow={arrow}>{children}</Inner>
  </button>
);
